import config from '@frolight/config';
import * as Sentry from '@sentry/react';

let sentryEnv = 'production';
if (process.env.NODE_ENV === 'production') {
  sentryEnv = 'production';
} else if (process.env.NODE_ENV === 'development') {
  sentryEnv = 'development'
}

Sentry.init({
  dsn: config.debugging.sentry.dsn,
  environment: sentryEnv
});

import './assets/styles/styles.scss';

import React from 'react';
import { createRoot } from 'react-dom/client';
import { createBrowserRouter, createRoutesFromElements, Route, RouterProvider } from 'react-router-dom';

import App from '@frolight/App';
import AppProviders from '@frolight/context/AppProviders';

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path="/*" element={<App />} />
  )
);

const container = document.getElementById('app');
const root = createRoot(container);
root.render(
  <React.StrictMode>
    <AppProviders>
      <RouterProvider router={ router } />
    </AppProviders>
  </React.StrictMode>
);
